import * as i0 from '@angular/core';
import * as i1 from './context-menu.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/cdk/bidi';
import * as i4 from '@angular/cdk/scrolling';
import * as i5 from '@angular/cdk/overlay';
import * as i6 from '@angular/cdk/portal';
import * as i7 from '../cdk/overlay/mapping';
import * as i8 from '../cdk/overlay/overlay-container';
import * as i9 from '../menu/menu.component';
import * as i10 from './context-menu.directive';
import * as i11 from './context-menu.component';
import * as i12 from '../cdk/overlay/overlay.module';
import * as i13 from '../menu/menu.module';
export const ElContextMenuModuleNgFactory:i0.NgModuleFactory<i1.ElContextMenuModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.Dir = (<any>(null as any));
var _decl0_12:i4.CdkFixedSizeVirtualScroll = (<any>(null as any));
var _decl0_13:i4.CdkScrollable = (<any>(null as any));
var _decl0_14:i4.CdkVirtualForOf<any> = (<any>(null as any));
var _decl0_15:i4.CdkVirtualScrollViewport = (<any>(null as any));
var _decl0_16:i5.CdkConnectedOverlay = (<any>(null as any));
var _decl0_17:i5.CdkOverlayOrigin = (<any>(null as any));
var _decl0_18:i6.CdkPortal = (<any>(null as any));
var _decl0_19:i6.CdkPortalOutlet = (<any>(null as any));
var _decl0_20:i7.ElPortalDirective = (<any>(null as any));
var _decl0_21:i7.ElPortalOutletDirective = (<any>(null as any));
var _decl0_22:i8.ElOverlayContainerComponent = (<any>(null as any));
var _decl0_23:i9.ElMenuComponent = (<any>(null as any));
var _decl0_24:i9.ElMenuItemComponent = (<any>(null as any));
var _decl0_25:i10.ElContextMenuDirective = (<any>(null as any));
var _decl0_26:i11.ElContextMenuComponent = (<any>(null as any));
var _decl0_27:i2.AsyncPipe = (<any>(null as any));
var _decl0_28:i2.UpperCasePipe = (<any>(null as any));
var _decl0_29:i2.LowerCasePipe = (<any>(null as any));
var _decl0_30:i2.JsonPipe = (<any>(null as any));
var _decl0_31:i2.SlicePipe = (<any>(null as any));
var _decl0_32:i2.DecimalPipe = (<any>(null as any));
var _decl0_33:i2.PercentPipe = (<any>(null as any));
var _decl0_34:i2.TitleCasePipe = (<any>(null as any));
var _decl0_35:i2.CurrencyPipe = (<any>(null as any));
var _decl0_36:i2.DatePipe = (<any>(null as any));
var _decl0_37:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_38:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_39:i2.KeyValuePipe = (<any>(null as any));
var _decl0_40:i2.CommonModule = (<any>(null as any));
var _decl0_41:i12.ElOverlayModule = (<any>(null as any));
var _decl0_42:i13.ElMenuModule = (<any>(null as any));
var _decl0_43:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_44:i0.ElementRef<any> = (<any>(null as any));
function _View_ElContextMenuComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_26.top;
  currVal_0;
  const currVal_1:any = _decl0_26.topStart;
  currVal_1;
  const currVal_2:any = _decl0_26.topEnd;
  currVal_2;
  const currVal_3:any = _decl0_26.right;
  currVal_3;
  const currVal_4:any = _decl0_26.endTop;
  currVal_4;
  const currVal_5:any = _decl0_26.endBottom;
  currVal_5;
  const currVal_6:any = _decl0_26.bottom;
  currVal_6;
  const currVal_7:any = _decl0_26.bottomStart;
  currVal_7;
  const currVal_8:any = _decl0_26.bottomEnd;
  currVal_8;
  const currVal_9:any = _decl0_26.left;
  currVal_9;
  const currVal_10:any = _decl0_26.startTop;
  currVal_10;
  const currVal_11:any = _decl0_26.startBottom;
  currVal_11;
}
function _View_ElContextMenuComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_26.context.tag;
  currVal_0;
  const currVal_1:any = _decl0_26.context.items;
  currVal_1;
}
